import type { UiInvoiceSatValidation } from '../../organisms/invoice-capture/invoice-capture.types';

export type UiInvoiceSubtotalItem = {
  tipo?: string;
  importe: string;
  subtotal?: string;
  sat: UiInvoiceSatValidation | null;
};

/** Subtotal comprobado: SubTotal del CFDI o importe total del comprobante general. */
export function invoiceSubtotal(item: UiInvoiceSubtotalItem): number {
  if (item.tipo === 'General') return invoiceMoneyToNumber(item.importe);
  if (item.subtotal && item.subtotal !== '—') {
    return invoiceMoneyToNumber(item.subtotal);
  }

  const total = invoiceMoneyToNumber(item.importe);
  if (!item.sat) return total;

  return (
    total -
    invoiceTax(item.sat, 'Impuesto al Valor Agregado (IVA)') +
    invoiceTax(item.sat, 'Retención ISR') +
    invoiceTax(item.sat, 'Retención IVA')
  );
}

export function invoicesSubtotal(items: readonly UiInvoiceSubtotalItem[]): number {
  return items.reduce((sum, item) => sum + invoiceSubtotal(item), 0);
}

export function invoiceSubtotalMatches(
  items: readonly UiInvoiceSubtotalItem[],
  expectedSubtotal: number,
): boolean {
  return Math.abs(invoicesSubtotal(items) - expectedSubtotal) < 0.01;
}

function invoiceTax(sat: UiInvoiceSatValidation, label: string): number {
  return invoiceMoneyToNumber(
    sat.impuestos.find(item => item.label === label)?.value ?? '',
  );
}

function invoiceMoneyToNumber(value: string): number {
  if (!value || value === '—') return 0;
  const number = Number(value.replace(/[^0-9.-]/g, ''));
  return Number.isFinite(number) ? number : 0;
}
